module.exports = __webpack_public_path__ + "img/wa04.5e8b328a.jpg";